import { render, staticRenderFns } from "./fontSizeFamilyForm.vue?vue&type=template&id=df8b4344&scoped=true"
import script from "./fontSizeFamilyForm.vue?vue&type=script&lang=js"
export * from "./fontSizeFamilyForm.vue?vue&type=script&lang=js"
import style0 from "./fontSizeFamilyForm.vue?vue&type=style&index=0&id=df8b4344&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8b4344",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df8b4344')) {
      api.createRecord('df8b4344', component.options)
    } else {
      api.reload('df8b4344', component.options)
    }
    module.hot.accept("./fontSizeFamilyForm.vue?vue&type=template&id=df8b4344&scoped=true", function () {
      api.rerender('df8b4344', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/allLayout/fontSizeFamilyForm.vue"
export default component.exports